import { STAGE_HOSTS } from '@common/constants';

export function getSentryEnvironment(): 'staging' | 'production' | 'local' {
  if (location.hostname.includes('localhost')) {
    return 'local';
  }

  if (location.hostname.includes('stage') || STAGE_HOSTS.includes(location.hostname)) {
    return 'staging';
  }

  return 'production';
}
